import getMetricInfo from '../../helpers/getMetricInfo';
import { BusinessHealthResponse } from '../../types';
import HealthMetricCard from '../HealthMetricCard';
import { healthMetricCards, HealthMetricCardConfig } from './constants';
import buildChannelsValue from './helpers/buildChannelsValue';
import buildSalesRatioValue from './helpers/buildSalesRatioValue';
import getStatusForComponent from './helpers/getStatusForComponent';
import isComponentIncluded from '../helpers/isComponentIncluded';
import getLabels from '../helpers/getLabels';

export interface HealthMetricsProps {
    isLoading?: boolean;
    data?: BusinessHealthResponse;
}

const renderCard = (metricsCard: HealthMetricCardConfig, data?: BusinessHealthResponse) => {
    if (!isComponentIncluded(metricsCard.groupKey, data)) return null;

    const labels = getLabels(metricsCard.groupKey, data);

    if (metricsCard.kind === 'salesRatio') {
        const {
            groupKey, title, icon, id,
        } = metricsCard;
        const status = getStatusForComponent(groupKey, data);
        const changeMetric = getMetricInfo('opportunities_win_rate');
        const value = buildSalesRatioValue(data?.metrics, data?.labels?.metrics);
        const change = data?.metrics?.opportunities_win_rate?.change;
        return (
            <HealthMetricCard
                key={id}
                title={labels?.label || title}
                icon={icon}
                status={status}
                value={value}
                changeMetricDefinition={changeMetric}
                change={change}
            />
        );
    }

    if (metricsCard.id === 'channels') {
        const {
            groupKey, title, icon, id,
        } = metricsCard;
        const status = getStatusForComponent(groupKey, data);
        const value = buildChannelsValue({ status, channels: data?.channels });
        return (
            <HealthMetricCard
                key={id}
                title={labels?.label || title}
                icon={icon}
                status={status}
                value={value}
            />
        );
    }

    const {
        groupKey, metricKey, title, icon, valueLabel, id,
    } = metricsCard;
    const status = getStatusForComponent(groupKey, data);
    const metricInfo = getMetricInfo(metricKey);
    const value = data?.metrics?.[metricKey]?.current
        ?? data?.healthscore?.components?.[metricKey]?.value;

    const change = data?.metrics?.[metricKey]?.change;
    return (
        <HealthMetricCard
            key={id}
            title={labels?.label || title}
            icon={icon}
            status={status}
            value={value}
            valueLabel={valueLabel}
            metricDefinition={metricInfo}
            change={change}
        />
    );
};

const HealthMetrics = ({ isLoading, data }: HealthMetricsProps) => (
    <>
        {healthMetricCards.map((metricsCard) => {
            if (isLoading) {
                return (
                    <HealthMetricCard
                        key={metricsCard.id}
                        isLoading
                        title={metricsCard.title}
                        icon={metricsCard.icon}
                        valueLabel={metricsCard.valueLabel}
                    />
                );
            }
            return renderCard(metricsCard, data);
        })}
    </>
);

export default HealthMetrics;
